module.exports = __webpack_public_path__ + "img/iconOrderTimes.4af5343b.svg";